import { Component, OnInit, OnDestroy, Input} from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { ReviewAllSolTabsComponent } from '../components/Review-SOL-Tabs/review-all-sol-tabs/review-all-sol-tabs.component';
import { ReviewDetailTabsService } from './review-detail-tabs.service';
import { ReviewService } from '../services/review.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CommonDataService } from '../services/common-data.service';

@Component({
  selector: 'lib-review-detail-tabs',
  imports: [
    MatCardModule,
    ReviewAllSolTabsComponent
  ],
  templateUrl: './review-detail-tabs.component.html',
  styles: [],
})
export class ReviewDetailTabsComponent implements OnInit, OnDestroy {

  @Input() isLibraryUsedInSQ: boolean = false;
  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly reviewDetailTabsService: ReviewDetailTabsService,
    private readonly reviewService: ReviewService,
  ) { }

  ngOnInit() {
    // The library's read-only flag is owned end-to-end by
    // `ReviewDetailComponent` in the app: it combines the app-level flag
    // (SAP-Submitted / collab / manual toggle) with the cost-review status
    // and pushes the single combined value via
    // `ReviewDetailTabsService.setReadOnlyMode(...)`. This component only
    // hydrates cost-review data and does NOT write to the read-only stream.
    this.setIsLibraryUsedInSQFlag();
    this.initializeCostReviewData();
    this.initializeCostReviewParametersData();
  }

    private setIsLibraryUsedInSQFlag() {
      this.reviewDetailTabsService.setIsLibraryUsedInSQ(this.isLibraryUsedInSQ);
    }

  initializeCostReviewData(){
    // Subscribe to review details data using the getter
    this.reviewDetailTabsService.getReviewDetailsData$
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {
          this.reviewService.setCostReviewData(data);
        },
        error: (error) => {}
      });
      this.reviewDetailTabsService.getBusiness$
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (business) => {
          this.reviewService.setBusiness(business);
        },
        error: (error) => {}
      });
  }

  initializeCostReviewParametersData(){ 
    // Subscribe to review parameter data (already existing)
    this.reviewDetailTabsService.getReviewParameterData$
      .pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        this.reviewService.setCostReviewParameterData(data);
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
